var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewfilter(_ref, svgRef) {
  var _ref2;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14099_179774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2584 2.40039H5.13844C3.61132 2.40039 2.84776 2.40039 2.37364 2.83986C1.89952 3.27933 1.89844 3.98761 1.89844 5.40309V6.1391C1.89844 7.24524 1.89844 7.79885 2.17924 8.25752C2.46004 8.71619 2.97088 9.00206 3.9958 9.57167L7.14184 11.321C7.82872 11.7029 8.17324 11.8938 8.41948 12.105C8.9314 12.5434 9.24676 13.0597 9.38932 13.6944C9.45844 13.9973 9.45844 14.3536 9.45844 15.0651V17.9131C9.45844 18.8827 9.45844 19.368 9.7306 19.7456C10.0028 20.1243 10.4866 20.311 11.4521 20.6843C13.4814 21.4673 14.4956 21.8587 15.217 21.4129C15.9384 20.967 15.9384 19.9494 15.9384 17.912V15.064C15.9384 14.3536 15.9384 13.9973 16.0076 13.6933C16.1432 13.0716 16.4849 12.5123 16.9785 12.104C17.2236 11.8938 17.5682 11.7029 18.255 11.32L21.4011 9.5706C22.4249 9.00206 22.9379 8.71726 23.2176 8.25859C23.4984 7.79992 23.4984 7.24524 23.4984 6.13803V5.40202C23.4984 3.98761 23.4984 3.27933 23.0232 2.83986C22.5502 2.40039 21.7866 2.40039 20.2584 2.40039Z",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14099_179774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.695312)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewfilter);
export default __webpack_public_path__ + "static/media/overviewfilter.c10579e7.svg";
export { ForwardRef as ReactComponent };